import useVehiclesMutations from "../../../data/useVehiclesMutations";
import useDefaultCRUDHandlers from "../../../hooks/useDefaultCRUDHandlers";
import { IPart } from "../../../models/Part";
import classNames from "../../../utils/classNames";

export default function UnlistedKTypeUpdate({ part }: { part: IPart }) {
  const { update } = useVehiclesMutations();
  const { saveHandlers } = useDefaultCRUDHandlers("KType");

  const handleKTypeUpdate = (kTypeString: string) => {
    if (!part.vehicle) return;


    let kType: number | null = parseInt(kTypeString);

    if (!kType) {
      kType = null;
    }

    if (part.vehicle?.kType == kType) return;

    const updateVehicle = {
      ...part.vehicle,
      kType: kType,
    };

    update.mutate(updateVehicle, {
      ...saveHandlers,
      onSuccess: () => {
        // queryClient.invalidateQueries(["pagedTable"]);
        saveHandlers.onSuccess();
        if (part.vehicle) {
          part.vehicle.kType = kType; // Update the vehicles kType in the local state
        }
      }
    });
  }

  return (
    <div className="flex items-center gap-x-2" onClick={(e) => e.stopPropagation()}>
      <label htmlFor={`kType-${part.id}`} className="text-xs text-gray-600">
        KType:
      </label>
      <input
        key={part.id}
        defaultValue={part.vehicle?.kType ?? ""}
        className={classNames("w-full text-xs h-6 border p-1 mr-6")}
        type="number"
        onBlur={(e) => handleKTypeUpdate(e.target.value)}
      />

    </div>
  )
}